import { Injectable } from '@angular/core';
import { jwtDecode } from 'jwt-decode';
import { UtilsService } from './utils.service';
import { Router } from '@angular/router';

@Injectable({
  providedIn: 'root'
})
export class TokenService {
  private expirationWarningShown = false;
  constructor(private utilSrv: UtilsService,
    private router: Router) { }

  decodeToken(token: string): any {
    try {
      return jwtDecode(token);
    } catch (error) {
      console.error('Invalid token:', error);
      return null;
    }
  }

  
  isTokenExpired(token: string): boolean {
    const decoded = this.decodeToken(token);
    if (!decoded || !decoded.exp) {

      return true; 
    }
    const currentTimeInSeconds = Math.floor(Date.now() / 1000);  

    const timeLeft = decoded.exp - currentTimeInSeconds ; 
    // Show a warning 5 seconds before expiration
     if (timeLeft <= 5 && !this.expirationWarningShown) {
      this.expirationWarningShown = true;
      this.showtoaster()
    }
    return timeLeft <= 0; // Return true if the token is expired
  }

  showtoaster(){
    this.utilSrv.showToastMessage('Your session is expired', 'error');
    // Trigger logout immediately after 1 seconds
    // setTimeout(() => {
    //   this.logout();
    // }, 2000);
  }

  logout() {
   this.utilSrv.logout()
  }

}
